var map = {
	"./acquired.png": 4557,
	"./augment.png": 5264,
	"./other.png": 7611,
	"./raid.png": 8713,
	"./shine.png": 5204,
	"./tome.png": 9512,
	"./twine.png": 2250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4502;